export default __webpack_public_path__ + "static/media/bitcoin.0fa182ac.svg";